module.exports = __webpack_public_path__ + "static/media/credit-card.6f1a3804.svg";